/**
 * @module app.model
 * @license Copyright 2017 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.BusinessDocumentCategory = function BusinessDocumentCategory(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.id =           obj.id != null ? parseInt(obj.id) : null;
        this.name =         obj.name ? obj.name : null;
    };

}(window.app));
